import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PublicRoute = ({ children }) => {
  const token = useSelector((state) => state.admin.token);
  return token ? <Navigate to="/" replace /> : children;
};

export default PublicRoute;
